import { useMemo } from 'react';
import useSelector from '~/store/useSelector';
import { getEventPayload } from './selectors';
import useConfirmAfterLogin from './useConfirmAfterLogin';
import useConfirmBeforeLogin from './useConfirmBeforeLogin';
import useLogInAndShowPreOrder from './useLogInAndShowPreOrder';
import useShowPreOrder from './useShowPreOrder';

export default function usePreOrder(): () => void {
  const eventPayload = useSelector(getEventPayload);
  const showPreOrder = useShowPreOrder(eventPayload);
  const confirmAfterLogin = useConfirmAfterLogin();
  const confirmBeforeLogin = useConfirmBeforeLogin();
  const logInAndShowPreOrder = useLogInAndShowPreOrder(eventPayload);

  return useMemo(
    () =>
      confirmBeforeLogin(
        logInAndShowPreOrder(confirmAfterLogin(showPreOrder), showPreOrder)
      ),
    [confirmAfterLogin, confirmBeforeLogin, logInAndShowPreOrder, showPreOrder]
  );
}
